var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2631_3742)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M341.333 497.365C314.624 506.837 285.909 512 256 512C226.091 512 197.376 506.837 170.667 497.365V448C170.667 400.939 208.939 362.667 256 362.667C303.061 362.667 341.333 400.939 341.333 448V497.365ZM256 149.333C232.469 149.333 213.333 168.469 213.333 192C213.333 215.531 232.469 234.667 256 234.667C279.531 234.667 298.667 215.531 298.667 192C298.667 168.469 279.531 149.333 256 149.333ZM512 256C512 350.571 460.459 433.301 384 477.632V448C384 377.408 326.592 320 256 320C185.408 320 128 377.408 128 448V477.632C51.5413 433.301 0 350.571 0 256C0 114.837 114.837 0 256 0C397.163 0 512 114.837 512 256ZM341.333 192C341.333 144.939 303.061 106.667 256 106.667C208.939 106.667 170.667 144.939 170.667 192C170.667 239.061 208.939 277.333 256 277.333C303.061 277.333 341.333 239.061 341.333 192Z",
    fill: "#505154"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2631_3742"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.994c3cf27920d24f11f2685e136e752d.svg";
export { ForwardRef as ReactComponent };